import React, { SetStateAction, Dispatch } from "react";
import {
  RaceProgram,
  RaceProgramRaceVideo,
  RaceVideoFeedback
} from "@tvg/ts-types/Race";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { Countries } from "@tvg/design-system";

import { Status } from "../../../types";
import MobileSubHeader from "./MobileSubHeader";
import SubHeader from "./DesktopSubHeader";

export interface MobileSubHeaderProps {
  country: Countries;
  title: string;
  isFavorite: boolean;
  onClickFavorite: () => void;
  video?: RaceProgramRaceVideo;
  videoFeedback?: RaceVideoFeedback;
  race: RaceProgram;
  races: Array<RaceProgram>;
  isLogged: boolean;
  mtp: number;
  status: Status;
  postTime: string;
  setIsMtpHidden: Dispatch<SetStateAction<boolean>>;
  onClickVideo: NullaryFn<void>;
  onClickPoolsNInfo: NullaryFn<void>;
  isMobile: boolean;
  isFavoriteLoading?: boolean;
}

const SubHeaderWrapper = (props: MobileSubHeaderProps) => {
  const {
    country,
    title,
    isFavorite,
    onClickFavorite,
    videoFeedback,
    race,
    races,
    isLogged,
    mtp,
    status,
    postTime,
    setIsMtpHidden,
    onClickVideo,
    onClickPoolsNInfo,
    isMobile,
    isFavoriteLoading
  } = props;

  return isMobile ? (
    <MobileSubHeader
      mtp={+mtp}
      status={status}
      postTime={postTime as string}
      setIsMtpHidden={setIsMtpHidden}
      onClickVideo={onClickVideo}
      onClickPoolsNInfo={onClickPoolsNInfo}
      race={race}
      races={races}
      country={country}
      title={title}
      isFavorite={isFavorite}
      isLogged={isLogged}
      onClickFavorite={onClickFavorite}
      videoFeedback={videoFeedback}
    />
  ) : (
    <SubHeader
      race={race}
      country={country}
      title={title}
      isFavorite={isFavorite}
      isLogged={isLogged}
      onClickFavorite={onClickFavorite}
      videoFeedback={videoFeedback}
      onClickFdrVideo={onClickVideo}
      isFavoriteLoading={isFavoriteLoading}
    />
  );
};

export default SubHeaderWrapper;
